

export enum GetExecutionsViewType {

    Flat = "flat",
    Tree = "tree"

}